var parser = function() {
    var p = {
        personalinfo: {},
        consentmainlabel: {},
        consent: {},
        consentemail: {},
        consentphone: {},
        consentpost: {},
        subscribe: {},
        contacttime: {},
        currentbrandselect: {},
        brochures: {},
        iscompany: {},
        retailers: {},
        retailersmodal: {},
        models: {},
        checkbox: {},
        dropdown: {},
        radiobutton: {},
        input: {},
        file: {},
        firstname: {},
        lastname: {},
        email: {},
        zipcode: {},
        pagebreak: {},
        submit: {},
        district: {},
        regnr: {},
        commisionnumber: {},
        address: {},
        co: {},
        company: {},
        phone: {},
        message: {},
        mobile: {},
        terms: {},
        gdprtext: {},
        testvehicleslots: {},
    };

    p.gdprtext.parse = function(form) {
        var parseRe = /\[gdprtext]/gi;
        var match = parseRe.exec(form);
        return match;
    };

    p.testvehicleslots.parse = function(form) {
        var parseRe = /\[testvehicleslots]/gi;
        var match = parseRe.exec(form);
        return match;
    };

    p.terms.parse = function(form) {
        var parseRe = /\[terms\s((.|\n|\r)*?)\]/gi;
        var match = parseRe.exec(form);
        if( match ) {
            match.required = true;
        }
        return match;
    };

    p.personalinfo.parse = function(form) {
        var parseRe = /\[personalinfo]/gi;
        var match = parseRe.exec(form);
        if( match ) {
            match.required = false;
        }
        return match;
    };

    p.consentmainlabel.parse = function(form) {
        var parseRe = /\[consentmainlabel]/gi;
        var match = parseRe.exec(form);
        return match;
    };

    p.consent.parse = function(form) {
        var parseRe = /\[consent(\*|)( forced|)]/gi;
        var match = parseRe.exec(form);
        if (match) {
            match.required = ( match[1] == '*' );
            match.forced = ( match[2] == ' forced' );
        }
        return match;
    };

    p.consentemail.parse = function(form) {
        var parseRe = /\[consentemail(\*?)]/gi;
        var match = parseRe.exec(form);
        if( match ) {
            match.required = true;
        }
        else {
            match = p.consent.parse(form);
        }
        return match;
    };

    p.consentphone.parse = function(form) {
        var parseRe = /\[consentphone(\*?)]/gi;
        var match = parseRe.exec(form);
        if( match ) {
            match.required = true;
        }
        else {
            match = p.consent.parse(form);
        }
        return match;
    };

    p.consentpost.parse = function(form) {
        var parseRe = /\[consentpost(\*?)]/gi;
        var match = parseRe.exec(form);
        if( match ) {
            match.required = true;
        }
        else {
            match = p.consent.parse(form);
        }
        return match;
    };

    p.subscribe.parse = function(form) {
        var parseRe = /\[subscribe(?:\:{1}([A-Za-z\d\,]+)?)?(\*?)\]/gi;
        var match = parseRe.exec(form);
        if( match ) {
            match.required = ( match[2] == '*' );
        }
        return match;
    };

    p.contacttime.parse = function(form) {
        var parseRe = /\[contacttime(\*?)]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.currentbrandselect.parse = function(form) {
        var parseRe = /\[currentbrandselect(\*?)]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.brochures.parse = function(form) {
        var parseRe = /\[brochures(?:\:{1}(pc|van|smart|truck)?([A-Za-z\d\,]+)?)?(\*?)\]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[3] == '*' );
        }
        return match;
    };

    p.iscompany.parse = function(form) {
        var parseRe = /\[iscompany\]/gi;
        var match = parseRe.exec(form);
        if( match ) {
            match.required = false;
        }
        return match;
    };

    p.retailers.parse = function(form) {
        var parseRe = /\[retailers(?:\:{1}(((pc|van|smart|truck){1}(_service){0,1}))?([A-Za-z\d\,]+)?)?(\*?)\]/gi;
        var match = parseRe.exec(form);
        if( match ) {
            match.required = ( match[6] == '*' );
        }
        return match;
    };

    p.retailersmodal.parse = function(form) {
        var parseRe = /\[retailersmodal(?:\:{1}(((pc|van|smart|truck){1}(_service){0,1}))?([A-Za-z\d\,]+)?)?(\*?)\]/gi;
        var match = parseRe.exec(form);
        if( match ) {
            match.required = ( match[6] == '*' );
        }
        return match;
    };

    p.models.parse = function(form) {
        var parseRe = /\[models(?:\:{1}(pc|van|truck)?([A-Za-z \-\d\,]+)?)?(\*?)\]/gi;
        var match = parseRe.exec(form);
        if( match ) {
            match.required = ( match[3] == '*' );
        }
        return match;
    };

    p.checkbox.parse = function(form) {
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.dropdown.parse = function(form) {
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.radiobutton.parse = function(form) {
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.input.parse = function(form) {
        var match = parseRe.exec(form);
        if( match ) {
            match.required = false;
        }
        return match;
    };

    p.file.parse = function(form) {
        var parseRe = /\[file(\*|)\]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.firstname.parse = function(form) {
        var parseRe = /\[firstname(\*|)\]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.lastname.parse = function(form) {
        var parseRe = /\[lastname(\*|)\]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.email.parse = function(form) {
        var parseRe = /\[email(\*|)\]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.zipcode.parse = function(form) {
        var parseRe = /\[zipcode(\*|)\]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.pagebreak.parse = function(form) {
        var parseRe = /(\/{3}\/*)(\#{1}[A-Za-z0-9\-]+)?/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.submit.parse = function(form) {
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.district.parse = function(form) {
        var parseRe = /\[district(\*|)\]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.regnr.parse = function(form) {
        var parseRe = /\[regnr(\*|)\]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.commisionnumber.parse = function(form) {
        var parseRe = /\[commisionnumber(\*|)\]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.address.parse = function(form) {
        var parseRe = /\[address(\*|)\]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.co.parse = function(form) {
        var parseRe = /\[co(\*|)\]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.company.parse = function(form) {
        var parseRe = /\[company(\*|)\]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.phone.parse = function(form) {
        var parseRe = /\[phone(\*|)\]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    p.message.parse = function(form) {
        var parseRe = /\[message(\({1}[\d]{1,}\){1})?(\:{1}[_]{1,})?(\*|)\]/gi;
        var match = parseRe.exec(form);
        if( match ) {
            match.required = ( match[3] == '*' );
        }
        return match;
    };

    p.mobile.parse = function(form) {
        var parseRe = /\[mobile(\*|)\]/gi;
        var match = parseRe.exec(form);
        if( match) {
            match.required = ( match[1] == '*' );
        }
        return match;
    };

    return p;
};

module.exports = new parser();



// WEBPACK FOOTER //
// ./parsing.js